@if (!isClientAdminView) {
  <app-autocomplete [id]="id"
                    [getDataFunction]="searchClientData.bind(this)"
                    [(value)]="selectedClientId"
                    [placeholder]="placeholder"
                    [enabled]="!isDisabled"
                    [isFormComponent]="isFormComponent"
                    [autoSelectOnSingleResult]="true"
                    (touched)="onTouched()">
  </app-autocomplete>
}
@else {
  <span>{{selectedClientName}}</span>
}
